export default __webpack_public_path__ + "static/media/color-h.14a9b53f.webp";